import { createFileRoute } from '@tanstack/react-router'
import { TermsOfUsePage } from '@/pages/TermsOfUsePage'

const TermsOfUse = () => {
  return <TermsOfUsePage />
}

export const Route = createFileRoute('/terms-of-use')({
  component: TermsOfUse,
})
